import { Box, Button } from '@mui/material';
import { IHomebannerDataListItem } from '../../../types/store';
import {
  ICommonDraggableTableColumnDef,
  IHomescreenBannerColumns,
} from '../../../types/commonDraggableTable';
import { EditButton } from '../../Buttons/EditButton';
import { DeleteButton } from '../../Buttons/DeleteButton';

export const getHomescreenBannerColumns = (
  onClickDelete: Function,
  navigateToEdit: Function,
): ICommonDraggableTableColumnDef<IHomescreenBannerColumns>[] => {
  return [
    {
      field: 'sequence',
      headerName: 'Sequence',
    },
    { field: 'name', headerName: 'Name' },
    {
      field: 'image_url',
      headerName: 'Image',
      renderCell: (value: any, row: any) => {
        return (
          <>
            <Box
              component="img"
              src={value}
              alt="No default img"
              sx={{
                height: '100px',
                width: '200px',
                maxWidth: '100%',
                objectFit: 'contain',
              }}
            />
          </>
        );
      },
    },
    {
      field: 'is_active',
      headerName: 'Active',
      renderCell: (value: any, row: any) => {
        return (
          <>
            <Button
              style={{ fontSize: 12, fontWeight: 600, flexShrink: 0 }}
              variant="contained"
              color={value ? 'success' : `error`}
            >
              {value ? 'Active' : 'Inactive'}
            </Button>
          </>
        );
      },
    },
    {
      field: 'data_list',
      headerName: 'Data List',
      renderCell: (value: any, row: any) => {
        return (
          <>
            {value?.map((item: IHomebannerDataListItem) => (
              <>
                {item.field_name}: {item.field_value}
              </>
            ))}
          </>
        );
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: (value, row) => {
        return (
          <>
            <EditButton
              onClick={() => {
                console.log(row);
                navigateToEdit(row);
              }}
            />
            <DeleteButton
              onClick={() => {
                onClickDelete(row);
              }}
            />
          </>
        );
      },
    },
  ];
};
